import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c7c3ff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-other-themes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      role: "button",
      class: "btn frost",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.action && _ctx.action(...args)))
    }, [
      _withDirectives(_createElementVNode("span", null, null, 512), [
        [_directive_translate, _ctx.otherThemeLabel()]
      ])
    ])
  ]))
}